export enum ORIENTATION {
  landscape = 'landscape',
  portrait = 'portrait',
}

export enum EXTENSION {
  pdf = 'pdf',
  csv = 'csv',
}

export enum FORMAT {
  pdf = 'pdf',
  csv = 'csv',
  statement = 'statement',
  tax = 'tax',
  payment = 'payment',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum DELIVERY_TYPE {
  download = 'download',
  email = 'email',
  contact = 'contact',
  user = 'user',
  tab = 'tab',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum GROUP_BY {
  none = 'null',
  contact = 'contact',
  program = 'program',
  department = 'department',
  account = 'account',
  bank_account = 'bank_account',
}

export const GROUP_BY_ITEMS = [
  { id: GROUP_BY.none, text: 'None' },
  { id: GROUP_BY.contact, text: 'Contact' },
  { id: GROUP_BY.program, text: 'Program' },
  { id: GROUP_BY.department, text: 'Department' },
  { id: GROUP_BY.account, text: 'Account' },
  { id: GROUP_BY.bank_account, text: 'Bank Account' },
];

export interface DownloadOptionsModel {
  file: string,
  orientation: ORIENTATION,
  format: FORMAT,
  delivery: DELIVERY_TYPE,
  payment_receipt?: boolean | null
  all?: boolean,
  export_to_grid?: boolean,
  group_by?: string | null,
}
